import * as React from "react";

const CheckMarkIcon = ({
  width = 13,
  height = 14,
  color, // solid color
  useGradient = false,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 13 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="checkGradient" x1="0" y1="0" x2="1" y2="1">
        <stop offset="16.46%" stopColor="#7B02CB" />
        <stop offset="100%" stopColor="#C102CB" />
      </linearGradient>
    </defs>

    <path
      d="M4.52282 13.015L4.48778 13.05C4.07897 13.05 3.74274 12.8816 3.4791 12.545L0.235322 8.29748C0.0417635 8.00915 -0.030821 7.69748 0.0175687 7.36248C0.0659584 7.02582 0.221973 6.74998 0.485614 6.53498C0.750923 6.31831 1.05795 6.23415 1.40669 6.28248C1.75376 6.33081 2.03575 6.49831 2.25267 6.78498L4.38015 9.55748L9.71386 1.02498C9.90575 0.738315 10.1636 0.558315 10.4873 0.484982C10.8126 0.413315 11.1313 0.461648 11.4434 0.629982C11.732 0.821648 11.9123 1.07998 11.984 1.40498C12.0558 1.72831 12.0074 2.04581 11.8388 2.35748L5.53149 12.4375C5.29121 12.8225 4.95499 13.015 4.52282 13.015Z"
      fill={useGradient ? "url(#checkGradient)" : color}
    />
  </svg>
);

export default CheckMarkIcon;
